import { render, staticRenderFns } from "./EditButtonForm.vue?vue&type=template&id=a87510a2&scoped=true"
import script from "./EditButtonForm.vue?vue&type=script&lang=js"
export * from "./EditButtonForm.vue?vue&type=script&lang=js"
import style0 from "./EditButtonForm.vue?vue&type=style&index=0&id=a87510a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87510a2",
  null
  
)

export default component.exports